import { restoresConstants } from '../constants'

const initialState = {
  list: null,
  loading: false,
  lot: ''
}

export default function restores(state = initialState, action) {
  switch (action.type) {
    case restoresConstants.LOADING_RESTORES:
      return {
        ...state,
        loading: true,
        lot: action.payload,
        list: null,
        error: null
      }
    case restoresConstants.LOADING_RESTORES_SUCCESS:
      return { ...state, loading: false, list: action.payload, error: null }
    case restoresConstants.LOADING_RESTORES_FAILURE:
      return { ...state, loading: false, error: action.payload }
    case restoresConstants.UPDATE_INTERVENTIONS:
      return { ...state, loading: true }
    case restoresConstants.UPDATE_INTERVENTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        list: state.list.map((x) =>
          x.id === action.payload.id ? action.payload : x
        )
      }
    case restoresConstants.UPDATE_INTERVENTIONS_FAILURE:
      return { ...state, loading: false }
    default:
      return state
  }
}
